import { Col, Row, Typography, Flex, Select, Input, Image } from "antd";
import { TITLE_TXT, DEAL_STATUS_LABEL_MAP } from "../../constants/constants";
import { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { count, dealStatusDropdown } from "../../redux/slices/DealSlice";
import { DEAL_CATEGORY_IDS } from "../../helpers/dealCategoryProducts";
import ArrowDownIcon from "../../assets/icons/arrow-down-icon.svg";
import DealsTable from "./Components/DealsTable";
import "./Deals.scss";

const { Title } = Typography;
const { Option } = Select;

const Deals = () => {
  const dispatch = useDispatch();
  const { dealsStatus, countData } = useSelector((state) => state?.deals);
  const { activeCategory } = useSelector((state) => state?.dealCategory || {});
  const user = useSelector((state) => state?.auth?.user);

  const currentDealCategoryId =
    activeCategory?.dealCategoryId ||
    user?.dealCategories?.[0]?.dealCategoryId ||
    DEAL_CATEGORY_IDS.INVOICE_FINANCING;

  const [selectedStatus, setSelectedStatus] = useState("pending");
  const [searchEnt, setSearchEnt] = useState("");

  useEffect(() => {
    dispatch(dealStatusDropdown());
    if (currentDealCategoryId) {
      dispatch(count({ type: "DEALS", dealCategoryId: currentDealCategoryId }));
    }
  }, [dispatch, currentDealCategoryId]);

  const statusCountMap = useMemo(() => {
    return (countData || [])
      .filter((item) => (item.dealCategoryId || DEAL_CATEGORY_IDS.INVOICE_FINANCING) === currentDealCategoryId)
      .reduce((acc, item) => {
        const status = item.statusName?.toLowerCase();
        const count = Number(item.count) || 0;

        if (
          status === "disbursed" ||
          status === "repaid" ||
          status === "approved" ||
          status === "agreement" ||
          status === "pending disbursal"
        ) {
          acc.ongoing = (acc.ongoing || 0) + count;
        } else if (status) {
          acc[status] = (acc[status] || 0) + count;
        }

        return acc;
      }, {});
  }, [countData, currentDealCategoryId]);

  const totalDealsCount = useMemo(
    () => Object.values(statusCountMap).reduce((sum, count) => sum + count, 0),
    [statusCountMap],
  );

  return (
    <div className="deals-container">
      <Title level={3} style={{ fontSize: 24 }}>
        {`${TITLE_TXT.DEALS} (${totalDealsCount})`}
      </Title>
      <Row align="middle" gutter={[0, 16]} justify="space-between">
        <Col>
          <Flex gap={20} justify="flex-end">
            <Input
              type="text"
              placeholder="Search Enterprise"
              style={{ width: 250 }}
              value={searchEnt}
              onChange={(e) => setSearchEnt(e.target.value)}
            />
            <Select
              style={{ width: 250 }}
              value={selectedStatus || undefined}
              suffixIcon={
                <Image src={ArrowDownIcon} alt="Arrow Down" preview={false} />
              }
              onChange={(value) => setSelectedStatus(value)}
            >
              {dealsStatus?.map((status) => (
                <Option key={status} value={status}>
                  {`${DEAL_STATUS_LABEL_MAP[status]} (${statusCountMap[status] || 0})`}
                </Option>
              ))}
            </Select>
          </Flex>
        </Col>
      </Row>
      <DealsTable
        selectedStatus={selectedStatus}
        searchEnt={searchEnt}
        currentDealCategoryId={currentDealCategoryId}
      />
    </div>
  );
};

export default Deals;
